module.exports = __webpack_public_path__ + "static/media/heads-together.002c0598.png";